export default {
  format(productName) {
    return productName.replaceAll(' ', '-').toLowerCase();
  },
  formatText(productName) {
    return productName.replaceAll('-', ' ').toLowerCase();
  },
};
